<script>
import { format, parseISO } from 'date-fns/fp'

export default {
  name: 'EventTile',
  props: {
    oneEvent: {
      type: Object,
      required: true,
    },
  },
  computed: {
    event() {
      const eventDetails =
        this.$store.state.events.eventDetails[this.oneEvent.id] || {}
      return {
        ...this.oneEvent,
        ...eventDetails,
        ...eventDetails.other_details,
      }
    },
    joinedUsersCount() {
      if (!this.event.joinedUsers) return this.event.joined_users_count

      const getGuestsCount = (acc, { pivot }) => acc + (pivot.guests_count || 0)
      const guestsCount = this.event.joinedUsers.reduce(getGuestsCount, 0)

      return this.event.joinedUsers.length + guestsCount
    },
    startDateFormatted() {
      return format('EEE, MMM d, Y', parseISO(this.event.start))
    },
    hoursFormatted() {
      return (
        format('hh:mm a', parseISO(this.event.start)) +
        ' - ' +
        format('hh:mm a', parseISO(this.event.end))
      )
    },
  },
  methods: {
    openEventModal() {
      this.$emit('open-modal')
    },
  },
}
</script>

<template>
  <div class="cursor-pointer event-box" @click="openEventModal">
    <div class="event-image">
      <img :src="event.image_url" loading="lazy" :alt="event.name" />
    </div>
    <div class="m-4.5">
      <h3 class="event-title">{{ event.name }}</h3>
    </div>
    <div class="event-meta">
      <div class="">
        <span class="event-date">{{ startDateFormatted }}</span>
        <span class="event-time">{{ hoursFormatted }}</span>
      </div>
      <div class="text-volunteer_red">
        {{ joinedUsersCount }}/{{ event.max_people }}
      </div>
    </div>
  </div>
</template>
